import styled, { useTheme } from "styled-components";
import Title from "common/Typography/Title";
import React, { useState } from "react";
import useUserAvatar from "@shared/common/Avatars/useUserAvatar";
import { userAvatarStyles } from "@shared/common/Avatars/styles";
import { UserAvatarProps } from "@shared/common/Avatars/types";

const UserAvatar = ({
  user,
  avatarSize,
  fallbackInitialsSize,
  isTelegramUser,
}: UserAvatarProps) => {
  const appTheme = useTheme();
  const { imageText } = useUserAvatar(user, isTelegramUser);
  // Falls back to the initials when the photo can't be loaded.
  const [failedImage, setFailedImage] = useState<string | null>();
  if (user.image && user.image !== failedImage) {
    return (
      <UserImage
        src={user.image}
        $size={avatarSize}
        onError={() => setFailedImage(user.image)}
      />
    );
  }

  return (
    <FallbackImage $size={avatarSize}>
      <Title
        level={fallbackInitialsSize}
        style={{ color: appTheme.colors.buttonText }}
      >
        {imageText}
      </Title>
    </FallbackImage>
  );
};

export default UserAvatar;

const UserImage = styled.img<{ $size: number }>`
  ${userAvatarStyles.userImage};
`;

const FallbackImage = styled.div<{ $size: number }>`
  ${userAvatarStyles.fallbackImage};
`;
